import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type IdentityProviderDeletionFailedAction = {
	type: 'IDENTITY_PROVIDER_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): IdentityProviderDeletionFailedAction => ({
	type: 'IDENTITY_PROVIDER_DELETION_FAILED',
	payload,
});
